import { BrandTypes } from '@ps/platform-message-framework/common/BrandTypes';
import { useTrackers } from '@ps/web-shared-analytics';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import type { RouteComponentProps } from 'react-router';
import { withRouter } from 'react-router';

import { select } from '@swf/core/store';

import Default from './components/Default/Default';
import FoxBet from './components/FoxBet/FoxBet';
import SportsMaintenance from './components/SportsMaintenance/SportsMaintenance';

const ServiceUnavailable: React.FC<RouteComponentProps> = ({ staticContext }) => {
  const { errorViewed } = useTrackers();

  useEffect(() => errorViewed({ errorCode: 'SYSTEM_UNAVAILABLE' }), [errorViewed]);

  if (staticContext) {
    staticContext.statusCode = 503;
  }

  switch (useSelector(select.cms.getBrandId)) {
    case BrandTypes.BET_STARS:
      return <SportsMaintenance />;
    case BrandTypes.FOX_BET:
      return <FoxBet />;
    default:
      return <Default />;
  }
};

export default withRouter(ServiceUnavailable);
